module.exports = __webpack_public_path__ + "static/img/produto_g.34fb395.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/produtos/citrus/produto_g.png
// module id = vX7M
// module chunks = 0